import * as React from 'react';
import { getDirectionsUrl } from '../../../services/maps-api';
import { useContext } from 'react';
//import { getToolTip } from '../../../services/tooltips';
import StatChart from '../../info/stat-chart';
import StatTable from '../../info/stat-table';
import { percentLabel } from "../../../utility/api-utilities";
import { AppContext } from '../../school-search-app';
import InfoBubble from '../../info/info-bubble';
import { PAGE_MODE } from '../../../interfaces';
function OverviewTab(props) {
    const school = props.school;
    const appContext = useContext(AppContext);

    const yesNo = (val) => val ? 'Yes' : 'No';

    const contacts = [
        { name: school.administratorFullName, title: school.administratorTitle },
        { name: school.secondContactFullName, title: school.secondContactTitle },
        { name: school.thirdContactFullName, title: school.thirdContactTitle },
        { name: school.fourthContactFullName, title: school.fourthContactTitle },
        { name: school.fifthContactFullName, title: school.fifthContactTitle },
        { name: school.sixthContactFullName, title: school.sixthContactTitle },
    ];

    //const hours = [
    //    { name: 'School Hours', time: school.freshmanHours },
    //    { name: 'HS Freshman School Hours', time: school.freshmanHours },
    //    { name: 'After School Hours', time: school.afterSchoolHours },
    //    { name: 'Earliest Drop Off', time: school.earliestDropOffTime },
    //];

    const transit = [
        { name: 'CTA Bus', options: school.transportationBus },
        { name: 'CTA Train', options: school.transportationEL },
        { name: 'Metra', options: school.transportationMetra },
    ];

    const leftStats = [
        { title: 'Bilingual Services', label: yesNo(school.hasBilingualServices) },
        { title: 'Classroom Languages', label: school.classroomLanguages },
        { title: 'Dress Code', label: yesNo(school.hasDressCode) },
        { title: 'Attendance Boundaries', label: yesNo(school.hasAttendanceBoundary) },
        { title: 'Refugee Services', label: yesNo(school.hasRefugeeServices) },
        { title: 'Title I Eligible', label: yesNo(school.isTitle1Eligible) },
    ];

    const rightStats = [
        { title: 'Campus Accessibility', label: school.campusAccessibility, tipKey: 'profile.overview.campusAccessibility' },
        { title: 'Parking Accessibility', label: school.parkingAccessibility, tipKey: 'profile.overview.parkingAccessibility' },
        { title: 'Transition Program', label: yesNo(school.hasTransitionProgram), tipKey: 'profile.overview.transitionProgram' },
        { title: 'Multisensory Program', label: yesNo(school.hasMultiSensoryProgram), tipKey: 'profile.overview.multisensoryProgram' },
        { title: 'Significantly Modified Curriculum W/Moderate Supports Program', label: yesNo(school.isSignificantlyModifiedModerate), tipKey: 'profile.overview.significantlyModifiedCurriculum' },
        {title: 'Accountability', label: school.overallRatingStatus ? school.overallRatingStatus : '', tipKey: 'profile.overview.accountability' },
    ];

    const studentPercent = (count, total) => {
        if (total != 0) {
            const percent = (count / total) * 100;
            return {
                label: percent.toFixed(1) + '%',
                percent: percent
            }
        }
        else {
            return {
                label: undefined,
                percent: undefined
            }
        }
    }

    const demographics = [
        { title: `Asian`, ...studentPercent(school.studentCountAsian, school.studentCount), },
        { title: `Black`, ...studentPercent(school.studentCountBlack, school.studentCount), },
        { title: `Hispanic`, ...studentPercent(school.studentCountHispanic, school.studentCount), },
        { title: `White`, ...studentPercent(school.studentCountWhite, school.studentCount), },
        { title: `Other`, ...studentPercent(school.studentCountMultiEthnic + school.studentCountNativeAmerican + school.studentCountHawaiianPacificIslander + school.studentCountEthnicityOther + school.studentCountAsianPacificIslander + school.studentCountEthnicityUnavailable, school.studentCount), },
    ];

    const stats = [
        { title: "Low  Income", ...studentPercent(school.studentCountLowIncome, school.studentCount), },
        { title: "Diverse Learners", ...studentPercent(school.studentCountSpecialEducation, school.studentCount), },
        { title: "Limited English", ...studentPercent(school.studentCountLimitedEnglishLearners, school.studentCount), },
        { title: "Mobility Rate", label: percentLabel(school._progressReport.mobility_Rate_Pct), percent: parseFloat(school._progressReport.mobility_Rate_Pct), tipKey: 'profile.overview.mobilityRate' },
        { title: "Chronic Truancy", label: percentLabel(school._progressReport.chronic_Truancy_Pct), percent: parseFloat(school._progressReport.chronic_Truancy_Pct), tipKey: 'profile.overview.chronicTruancy' },
    ]

    let basics = [
        { label: 'School Type', value: 'CPS - Based' },
        { label: 'Address', value: `${school.addressStreet}, ${school.addressCity}, ${school.addressState} ${school.addressZipCode}` },
        { label: 'Duration', value: 'School Year' },
        { label: 'Phone', value: school.phone },
        { label: 'Fax', value: school.fax },
    ];

    if (appContext.mode == PAGE_MODE.GOCPS) {
        basics = basics.filter(data => data.label != 'School Type');
        basics = basics.filter(data => data.label != 'Duration');
        basics.push({ label: 'Network', value: school.network });
    }

    const basics2 = [
        { label: 'School Day', value: school.preKSchoolDay },
        { label: 'School Hours', value: school.schoolHours },
        { label: 'Earliest Drop Off Time', value: school.earliestDropOffTime },
    ]

    // @TODO this should be pulled into a component probably, shared with prek
    const basicInfo = (info) => {
        return info.value &&
            <div key={info.label} className="info">
                <span className="label">{info.label}: </span>
                <span className="value">{info.value}</span>
            </div>
    }

    //const overallRatingInfoBubble = school.overallRatingDescription ? <InfoBubble index="infoBuble1" tip={school.overallRatingDescription} placement={'right'} /> : <></>;
  
    const GovernanceInfoBubble = <InfoBubble index="infoBuble1" tip="Per Chicago Board of Education policy, this school’s accountability status is carrying over from SY 2020-2021." placement={'right'} />;
    const schoolTransit = transit.filter(contact => contact.options);

    return <div className="tab-content">
        <div className="main-overview profile-section container-fluid">
            <div className="row main-school-info">
                <div className="col-sm-9">
                    <div className="content">
                        <h2>{school.schoolShortName}</h2>
                        <h3>{school.schoolLongName}</h3>
                        <div dangerouslySetInnerHTML={{ __html: school.introduction }}></div>
                    </div>
                </div>
                <div className="col-sm-3 prek-profile-buttons">
                    {school.websiteURL && <a className="btn" target="_blank" href={school.websiteURL} >View Website</a>}
                    <a className="btn" target="_blank" href={getDirectionsUrl(`${school.addressStreet}, ${school.addressCity}, ${school.addressState} ${school.addressZipCode}`)}>Directions</a>
                    <div className="socials-networks">
                        {school.facebookURL && <a className="btn-social" target="_blank" href={school.facebookURL} ><span className="fab fa-facebook-f social-icon" id="facebook"></span></a>}
                        {school.youtubeURL && <a className="btn-social" target="_blank" href={school.youtubeURL} ><span className="fab fa-youtube social-icon" id="youtube"></span></a>}
                        {school.twitterURL && <a className="btn-social" target="_blank" href={school.twitterURL} ><span className="fab fa-twitter social-icon" id="twitter"></span></a>}

                    </div>
                </div>
            </div>
            <div className="row basics">
                <div className={`col-sm-6 info-block ${appContext.mode == PAGE_MODE.GOCPS && 'gocpsInfoBlock'}`}>
                    <h3>School Information</h3>
                    {basics.map(info => basicInfo(info))}
                </div>
                {
                    appContext.mode !== 'gocps' &&
                    <div className="col-sm-6 info-block">
                        <h3>Duration and Hours</h3>
                        {basics2.map(info => basicInfo(info))}
                    </div>
                }

            </div>
            <div className="row basics">
                <div className="col">
                    <div className={`basics-columns ${appContext.mode == PAGE_MODE.GOCPS && 'gocpsInfoBlock'}`}>
                        <div className="basics-block">
                            <div className="header">
                                <div className="title">School Grades</div>
                                <div className="value">{school.gradesOfferedReadable}</div>
                            </div>
                        </div>
                        <div className="basics-block">
                            <div className="header">
                                <div className="title"># of Students</div>
                                <div className="value">{school.studentCount}</div>
                            </div>
                        </div>
                        <div className="basics-block">
                            <div className="header">
                                <div className="title">Governance</div>
                                <div className="value">{school.governance} {GovernanceInfoBubble}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="promos">
                        <div className="promo-block blue">
                            <h3>Faculty</h3>
                            {contacts.filter(contact => contact.name != '').map(contact => <div key={contact.title} className="info-block">
                                <div className="title">{contact.name}</div>
                                <div className="sub-title">{contact.title}</div>
                            </div>)}
                        </div>
                        <div className="promo-block dark-blue">
                            <h3>Hours</h3>
                            <div className="info-block">
                                <div className="title">{school.schoolHours}</div>
                                <div className="sub-title"> School Hours</div>
                            </div>
                            <div className="info-block"></div>
                            <div className="info-block">
                                <div className="title">{school.earliestDropOffTime}</div>
                                <div className="sub-title">Earliest drop Off</div>
                            </div>

                        </div>
                        <div className="promo-block purple">
                            <h3>Public Transit</h3>
                            {schoolTransit.length > 0
                                ? schoolTransit.map(contact =>
                                    <div key={contact.name} className="info-block">
                                        <div className="title">{contact.name}</div>
                                        <div className="sub-title">{contact.options}</div>
                                    </div>)
                                : <div className="sub-title">Not Reported</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="row statistics">
                <div className="col-sm-6 stat-block">
                    <h3>Demographics</h3>
                    <p>{school.demographicsSummary}</p>
                    <StatChart header="" stats={demographics} />
                </div>
                <div className="col-sm-6 stat-block">
                    <h3>Statistics</h3>
                    <p>{school.statisticsSummary}</p>
                    <StatChart header="" stats={stats} />
                </div>
            </div>
            <div className="row features">
                <div className="col-sm-6">
                    <StatTable stats={leftStats} />
                </div>
                <div className="col-sm-6">
                    <StatTable stats={rightStats} />
                </div>
            </div>
        </div >
        <div className="sidebar-overview">
        </div>
    </div>;
}

export default OverviewTab;